import {Link} from "react-router-dom";

const FallbackPage = () => {
    return <div className={"container bg-light min-vh-100"}>
        <h1>404 - Page Not Found</h1>
        <p>Oops! The page you're looking for does not exist.</p>
        <Link to={"/"}>Go to Homepage</Link>
    </div>
}
export default FallbackPage;